import { createFileRoute } from "@tanstack/react-router";

import FeedbackAdmin from "@/components/admin/FeedbackAdmin";

// A passthrough like its siblings: the console component owns everything, and
// `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/feedback")({
  component: FeedbackAdmin,
});
